import React from 'react';
import ReactMarkdown from 'react-markdown';
import RemarkGFM from 'remark-gfm';
import { Loading } from '@appkit4/react-components/loading';
import { Panel } from '@appkit4/react-components/panel';
import useGenericErrorToast from '../../helpers/useGenericErrorToast';
import './Policy.scss';
import { useGetV1PolicyPrivacy } from '../../api/generated/endpoint';
import useLocale from '../../locale/useLocale';
import useTitle from '../../helpers/useTitle';

const Privacy = () => {
    const showGenericErrorToast = useGenericErrorToast();
    const { l } = useLocale();
    useTitle(l('_privacyPolicyTitleCase'));

    const { data: privacyPolicy } = useGetV1PolicyPrivacy({
        query: {
            onError: showGenericErrorToast,
        },
    });

    return (
        <div>
            {privacyPolicy ? (
                <>
                    <h1 data-cy="privacy-policy-title">
                        {l('_privacyPolicyTitleCase')}
                    </h1>
                    <Panel className="panel">
                        <ReactMarkdown remarkPlugins={[RemarkGFM]}>
                            {privacyPolicy.text}
                        </ReactMarkdown>
                    </Panel>
                </>
            ) : (
                <Loading loadingType="circular" indeterminate compact={false} />
            )}
        </div>
    );
};

export default Privacy;
